// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1931":"c9422f6a","2294":"454d7c6d","5054":"447f7ff3","6198":"2ef8fbaf","7017":"4d6c22f7","7832":"7fbb866f"}[chunkId] + ".chunk.css";
};